import { render, staticRenderFns } from "./NewsMain.vue?vue&type=template&id=100039c8&scoped=true&"
import script from "./NewsMain.vue?vue&type=script&lang=js&"
export * from "./NewsMain.vue?vue&type=script&lang=js&"
import style0 from "./NewsMain.vue?vue&type=style&index=0&id=100039c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100039c8",
  null
  
)

export default component.exports